import * as http from 'utils/http';
import config from 'config';
import serialize from 'utils/serialize';

const createAndOfferPrebooking = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const {
        route: { origin, destination },
        vehicle_type,
        start_date,
        end_date,
      } = data;

      const driversParams = serialize({
        route: `${origin}->${destination}`,
        vehicle_type,
        start_date,
        end_date,
      });

      const drivers = await http.get(`${config.API_URL}prebookings/drivers/?${driversParams}`);

      const prebooking = await http.post(`${config.API_URL}prebookings/`, data);
      const { id } = prebooking;

      await http.post(`${config.API_URL}prebooking_offers/`, {
        prebooking: id,
        driver_ids: drivers,
      });

      return resolve(prebooking);
    } catch (err) {
      reject(await http.getError(err));
    }
  });
};

export default createAndOfferPrebooking;
